import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-10" }
const _hoisted_2 = { class: "flex justify-end -mt-4 -mr-2" }
const _hoisted_3 = { class: "space-y-4 animate-fade-in animate-delay-100" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "section-title mb-0" }
const _hoisted_6 = { class: "flex items-center gap-2 text-sm text-stone-600 dark:text-stone-300" }
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = { class: "space-y-3" }
const _hoisted_9 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_10 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_11 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "text-sm text-stone-500 dark:text-stone-500"
}

import DarkModeToggle from "@/components/common/DarkModeToggle.vue";
import AboutSection from "@/components/AboutSection.vue";
import ExperienceList from "@/components/ExperienceList.vue";
import ProjectList from "@/components/ProjectList.vue";
import { usePortfolioStore } from "@/store/portfolioStore";
import { storeToRefs } from "pinia";
import { onMounted, computed, ref } from "vue";
import { Experience } from "../types/experienceType";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const portfolioStore = usePortfolioStore();

const { portfolio } = storeToRefs(portfolioStore);

const { loadPortfolio } = portfolioStore;

const sortedExperiences = computed<Experience[]>(() => {
  const experiences = portfolio.value?.experiences || [];

  return [...experiences].sort((a, b) => {
    const dateA = new Date(a.to || a.from).getTime();
    const dateB = new Date(b.to || b.from).getTime();
    return dateB - dateA;
  });
});

const resumeLink = computed(() => {
  return portfolio.value?.resumeUrl || "/resume.pdf";
});

const slides = ref(["about", "experience", "projects", "resume"]);
const currentSlide = ref(0);

const currentSlideKey = computed(() => slides.value[currentSlide.value]);
const currentTitle = computed(() => {
  if (currentSlideKey.value === "about") return "About";
  if (currentSlideKey.value === "experience") return "Experience";
  if (currentSlideKey.value === "projects") return "Projects";
  return "Resume";
});

const goTo = (index: number) => {
  if (index >= 0 && index < slides.value.length) {
    currentSlide.value = index;
  }
};

onMounted(async () => {
  await loadPortfolio();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DarkModeToggle)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(currentTitle.value), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slides.value.length, (_, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              type: "button",
              "aria-label": `Go to slide ${i + 1}`,
              onClick: ($event: any) => (goTo(i)),
              class: _normalizeClass(["h-2 w-2 rounded-full transition-colors", 
              i === currentSlide.value
                ? 'bg-brand-600 dark:bg-brand-300'
                : 'bg-stone-400/50 dark:bg-stone-600/60'
            ])
            }, null, 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_Transition, {
          name: "slide-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: currentSlideKey.value,
              class: "space-y-3"
            }, [
              (currentSlideKey.value === 'about')
                ? (_openBlock(), _createBlock(AboutSection, {
                    key: 0,
                    about: _unref(portfolio)?.about
                  }, null, 8, ["about"]))
                : (currentSlideKey.value === 'experience')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedExperiences.value, (experience) => {
                        return (_openBlock(), _createBlock(ExperienceList, {
                          key: experience._id,
                          experience: experience,
                          useIcon: _unref(portfolio)?.isSvg
                        }, null, 8, ["experience", "useIcon"]))
                      }), 128))
                    ]))
                  : (currentSlideKey.value === 'projects')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(portfolio)?.projects, (project) => {
                          return (_openBlock(), _createBlock(ProjectList, {
                            key: project._id,
                            project: project
                          }, null, 8, ["project"]))
                        }), 128))
                      ]))
                    : (currentSlideKey.value === 'resume')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          (resumeLink.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-stone-700 dark:text-stone-300" }, " Download my latest CV to view experience, skills, and projects. ", -1)),
                                _createElementVNode("a", {
                                  href: resumeLink.value,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "inline-flex items-center gap-2 text-sm font-semibold text-stone-800 dark:text-stone-100 hover:text-stone-600 dark:hover:text-stone-200 transition-colors"
                                }, [...(_cache[0] || (_cache[0] = [
                                  _createElementVNode("span", null, "Download Resume", -1),
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "1.5",
                                      d: "M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"
                                    })
                                  ], -1)
                                ]))], 8, _hoisted_12)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, " Resume not available. "))
                        ], 64))
                      : _createCommentVNode("", true)
            ]))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})